export default {
  BASE_URL: process.env.VUE_APP_BASE_URL || 'http://localhost:8080/',
  API_URL: process.env.VUE_APP_API_URL || 'http://localhost:5000/api/',
  ETA_URL: process.env.VUE_APP_ETA_URL || 'http://localhost:12340/api/',
  WS_URL: process.env.VUE_APP_WS_URL || 'ws://localhost:4000/socket',
  APP_NAME: process.env.VUE_APP_NAME || 'Flow Automação',
  STORAGE_KEY: process.env.VUE_APP_STORAGE_KEY || 'flow-automacao',
  VAPID_KEY:
    process.env.VUE_APP_VAPID_KEY ||
    'BKVAX0lgeGnhg1q3ekWhUkSr3OHdb0DVY0RxAAvAtZRpO7Wd1Qyb9fi7yUgYngTO4CpTd9wdnZ0nqdixhoJj910',
  MAPBOXGL_ACCESSTOKEN:
    process.env.VUE_APP_MAPBOXGL_ACCESSTOKEN ||
    'pk.eyJ1IjoiZmxvdy1hdXRvbWFjYW8iLCJhIjoiY203MGtjdWxzMDJ4eDJtcHgwMzAwdG8wZSJ9.NTTA1b5_KmpgFPVXYom1-w',
  FIREBASE_CONFIG: {
    API_KEY: process.env.VUE_APP_FIREBASE_API_KEY || '',
    AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || '',
    DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL || '',
    PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID || '',
    STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || '',
    MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    APP_ID: process.env.VUE_APP_FIREBASE_APP_ID || '',
    MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || '',
  },
  SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN || '',
}
